import { useNavigate } from 'react-router';
import { useTranslation } from '../../../hooks/useTranslation';
import { CategoryDto } from '../../../commonTypes/documents.types';
import { PremiumTooltip } from '../../../components/Common/PremiumTooltip';
import cc from 'classcat';

interface ICard {
    category: CategoryDto;
    onDelete: (id: string) => void;
    documentCount: number;
    isDisabled?: boolean;
    showPremiumTooltip?: boolean;
}

export const Card = ({ category, onDelete, documentCount, isDisabled = false, showPremiumTooltip = false }: ICard) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const formatDocumentCount = (documentCount: number) => {
        if (documentCount === 1) return 'documents.document';
        if (documentCount > 1 && documentCount < 5) {
            return 'documents.documents';
        }
        return 'documents.documents2';
    };

    const handleEdit = () => {
        if (!isDisabled) {
            navigate(`/category/${category.id}/edit`);
        }
    };

    const handleDelete = () => {
        if (!isDisabled) {
            onDelete(category.id);
        }
    };

    return (
        <div
            className={cc([
                'documents__card',
                isDisabled && 'documents__card--disabled',
                isDisabled && showPremiumTooltip && 'premium-tooltip-wrapper',
            ])}
        >
            <div className="documents__title">
                <h4 className={cc(['documents__name', isDisabled && 'documents__name--disabled'])}>{category.name}</h4>
                {category.name === 'General Documents' && (
                    <p className="documents__isMain documents__text--grey">({t('documents.defaultCategory')})</p>
                )}
            </div>
            <p className={cc(['paragraph-3', isDisabled && 'documents__description--disabled'])}>{category.description}</p>
            <div className="documents__columns">
                <p className={cc(['paragraph-3', isDisabled && 'documents__count--disabled'])}>
                    {documentCount} {t(formatDocumentCount(documentCount))}
                </p>
            </div>
            <div className="documents__actions">
                <button
                    className="documents__button"
                    onClick={handleEdit}
                    disabled={isDisabled}
                    style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}
                >
                    <img src="/svg/pen-grey.svg" alt="edit" />
                </button>
                {category.name !== 'General Documents' && (
                    <button
                        className="documents__button"
                        onClick={handleDelete}
                        disabled={isDisabled}
                        style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}
                    >
                        <img src="/svg/trash.svg" alt="delete" />
                    </button>
                )}
            </div>
            {isDisabled && showPremiumTooltip && <PremiumTooltip position="top" showOnHover />}
        </div>
    );
};
